<template>
  <section class="jobs">
    <columns :is-multiline="true">
      <column v-for="item in skeletonCard" :key="item" size="is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
        <card>
          <div class="container ">
            <div class="skeleton-img"></div>
            <div class="mt-2"></div>
            <h2 class="skeleton-name mt-2"></h2>
            <h2 class="skeleton-name  mb-2"></h2>
            <h4 class="skeleton-email"></h4>
            <h4 class="skeleton-email"></h4>
          </div>
          <hr>
          <split-section :companies="companies">
            <template slot="left">
              <div>
                <h4 class="skeleton-email"></h4>
                <h4 class="skeleton-email"></h4>
              </div>
            </template>
            <template slot="right">
              <div>
                <h4 class="skeleton-email"></h4>
                <h4 class="skeleton-email"></h4>
              </div>
            </template>
            <h4 class="skeleton-email"></h4>
          </split-section>
        </card>
      </column>
    </columns>
  </section>
</template>
<script>
import Heading from '@/components/general/heading'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import JobsNav from '@/components/jobs/nav'
import JobCard from '@/components/jobs/job-card'
import EmptyState from '@/components/general/empty-state'
import Card from '@/components/general/card'
import Container from '@/components/general/container'
import SplitSection from '@/components/general/split-section'
import {skeletonCard} from '@/constants/array-constants'

export default {
  name: 'jobs-skeleton',
  components: {
    Container,
    JobsNav,
    JobCard,
    Heading,
    Columns,
    Column,
    EmptyState,
    Card,
    SplitSection
  },
  props: {
    companies: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      skeletonCard
    }
  }
}
</script>
<style lang="scss" scoped>
.jobs {
  .list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    li {
      flex-basis: 20rem;
      margin-bottom: 1rem;
      border: 1px solid #ddd;
      background-color: #fff;
      margin-right: 1rem;
      border-radius: .5rem;
    }
  }
}

h2.heading {
  margin-bottom: 16px;
}

.column {
  padding: 0.5rem;
}

.column {
  margin-bottom: 2px;
}

@media (max-width:480px)  {
  .jobs .list > li {
    flex-grow: 1;
  }
}

@keyframes loading {
  0% {
    transform: translateX(0);
  }
  50%,
  100% {
    transform: translateX(460px);
  }
}

.skeleton-item {
  display: flex;
  align-items: center;
  margin: 15px 0;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  position: relative;
}

.skeleton-img::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 100%;
  background: linear-gradient(to right, #f2f2f2, #ddd, #f2f2f2);
  animation: loading 2s infinite linear;
}

.skeleton-img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f2f2f2;
  position: relative;
  overflow: hidden;
}

.skeleton-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
}

.skeleton-name {
  width: 100%;
  height: 18px;
  background: #f2f2f2;
  position: relative;
  overflow: hidden;
}

.skeleton-name::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 100%;
  background: linear-gradient(to right, #f2f2f2, #ddd, #f2f2f2);
  animation: loading 2s infinite linear;
}

.skeleton-email {
  width: 85%;
  height: 18px;
  background: #f2f2f2;
  margin-top: 3px;
  position: relative;
  overflow: hidden;
}

.skeleton-email::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 100%;
  background: linear-gradient(to right, #f2f2f2, #ddd, #f2f2f2);
  animation: loading 2s infinite linear;
}
.container{
  display: flex;
  flex-direction: column;
}
.mt-2{
  margin-top: 16px;
}

.mb-2{
  margin-bottom: 16px;
}
hr{
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/jobs-skeleton.vue